import layout from '@/views/layout/layout.vue'
const redPacketDateList = r => require.ensure([], () => r(require('@/views/marketing/redPacketDate/list.vue')), 'group-marketing-redPacketDate')

const marketingRedPacketDate = [
  {
    path: '/marketing/redPacketDate',
    name: 'marketing-redPacketDate',
    component: layout,
    redirect: '/marketing/redPacketDate/list',
    hidden: true,
    children: [
      {
        path: 'list',
        component: redPacketDateList,
        name: 'marketing-redPacketDate-list',
        meta: {
          displayName: '抽奖个人记录管理',
          requireAuth: true
        }
      }
    ]
  }
]

export default marketingRedPacketDate



// WEBPACK FOOTER //
// ./src/router/marketing/RedPacketDate.js